export default [
  {
    path: "/consignorSetting",
    component: () =>
      import(
        /* webpackChunkName: "consignor" */ "@/views/consignor/consignorManage/index"
      ),
    name: "consignorSetting",
    meta: {
      isTab: true,
      keepAlive: false,
      links: ["委托方管理"],
      permissionsPath: "/consignorSetting"
    }
  },

  {
    path: "/consignorDetail",
    component: () =>
      import(
        /* webpackChunkName: "consignor" */ "@/views/consignor/consignorManage/detail"
      ),
    name: "consignorDetail",
    meta: {
      isTab: false,
      keepAlive: false,
      links: ["委托方详情"],
      permissionsPath: "/consignorSetting"
    }
  },
  {
    path: "/consignorHome",
    component: () =>
      import(
        /* webpackChunkName: "consignor" */ "@/views/consignor/consignorHome/index"
      ),
    name: "consignorHome",
    meta: {
      isTab: true,
      keepAlive: true,
      links: ["委托方首页"],
      permissionsPath: "/consignorHome"
    }
  }
];
